import { List, Map } from 'immutable';

import * as constants from './constants';
import * as types from './types';


const initialState = Map({
  commandsFilter: {
    phrase: '',
    hasScreenshot: false,
    hasRootCause: false,
    showFailedTests: false,
  },
  galleryFullScreen: false,
  loading: true,
  notifications: List(),
  player: {},
  ratio: JSON.parse((
    window.localStorage.getItem(constants.LS_TEST_DETAILS_COLUMNS_RATIO) ||
    constants.INITIAL_COLUMNS_RATIO
  )),
});

const containerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.INITIALIZE.SUCCESS:
      return state.set('loading', false);
    case types.VIDEO_PLAYER_MOUNTED:
      return state.set('player', payload);
    case types.UPDATE_COLUMNS_RATIO:
      window.localStorage.setItem(constants.LS_TEST_DETAILS_COLUMNS_RATIO, payload);
      return state.set('ratio', payload);
    case types.APPEND_NOTIFICATION: {
      const notifications = state.get('notifications');
      return state.set('notifications', notifications.push(payload));
    }
    case types.UPDATE_COMMANDS_FILTER:
      return state.set('commandsFilter', {
        ...state.get('commandsFilter'),
        ...payload,
      });
    case types.SET_GALLERY_FULL_SCREEN:
      return state.set('galleryFullScreen', payload);
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default containerReducer;
